import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import DocuSyncTableHead from './DocuSyncTableHead';

function DocuSyncSkeleton() {
  return (
    <Box>
      <Stack direction="row" alignItems="center" mb={2}>
        <Typography variant="pageTitle">Docu-Sync</Typography>
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
      </Stack>

      <Paper>
        <Toolbar className="justify-content-end border-bottom">
          <Stack direction="row" justifyContent="flex-end" flexWrap="wrap" gap={1}>
            <Skeleton variant="rounded" width={140} height={36} />
            <Skeleton variant="rounded" width={120} height={36} />
          </Stack>
        </Toolbar>

        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <DocuSyncTableHead />

            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Stack direction="row" gap={2} alignItems="center">
                      <Skeleton animation="wave" variant="circular" width={24} height={24} />
                      <Skeleton animation="wave" variant="text" width="60%" height={24} />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="70%" height={24} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 2 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default DocuSyncSkeleton;
